/*
  カートに入れた後に右から開くカート（sections/cart-drawer.liquid）
  window.CartDrawer
    - add(items): /cart/add.js で追加し、カートと [data-cart-refresh-section] のセクションを作り直して、カートを開く
      items は [{ id: バリエーションID, quantity: 数量 }]。失敗したときは Error（説明文つき）で reject
    - open() / close()
  - [data-cart-add="バリエーションID"] のボタンは、押すと1点追加する
  - 追加の後、ヘッダーのカート数（[data-cart-count]）を書き換え、document に cart:updated（detail: count / total）を出す
*/
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var lastFocus = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function sectionIds() {
    var ids = [SECTION_ID];
    document.querySelectorAll('[data-cart-refresh-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-refresh-section');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  // Section Rendering API の HTML は外側の #shopify-section-ID を含むので、中身だけ差し替える
  function applySections(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      var current = document.getElementById('shopify-section-' + id);
      if (!html || !current) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body;

      // 開いているカートを作り直すときは、開いた状態のまま差し替える（開くアニメーションを繰り返さない）
      var openDrawer = current.querySelector('[data-cart-drawer].is-open');
      var freshDrawer = fresh.querySelector('[data-cart-drawer]');
      if (openDrawer && freshDrawer) freshDrawer.classList.add('is-open');

      current.innerHTML = fresh.innerHTML;
    });
  }

  function updateCount() {
    var el = drawer();
    if (!el) return;
    var count = Number(el.getAttribute('data-item-count')) || 0;
    var total = Number(el.getAttribute('data-total')) || 0;

    // ヘッダーのカート数（[data-cart-count] を書き換えると PC ヘッダーも連動して更新）
    var countEl = document.querySelector('[data-cart-count]');
    var bubble = document.querySelector('[data-cart-count-bubble]');
    if (countEl) countEl.textContent = count > 0 ? count : '';
    if (bubble) bubble.classList.toggle('hide', count === 0);

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count, total: total } }));
  }

  function open() {
    var el = drawer();
    if (!el) return;
    if (!el.classList.contains('is-open')) lastFocus = document.activeElement;
    el.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
    var panel = el.querySelector('.cart-drawer__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function showError(message) {
    var el = drawer();
    var errorEl = el && el.querySelector('[data-cart-drawer-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function add(items) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionIds().join(','),
        sections_url: location.pathname + location.search
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'カートに追加できませんでした');
          return data;
        });
      })
      .then(function (data) {
        applySections(data.sections);
        updateCount();
        open();
        return data;
      });
  }

  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-cart-drawer-close]')) {
      close();
      return;
    }

    var btn = evt.target.closest('[data-cart-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    add([{ id: Number(btn.getAttribute('data-cart-add')), quantity: 1 }])
      .catch(function (err) {
        open();
        showError(err.message);
      })
      .then(function () {
        // 追加に成功するとボタンごと作り直されるので、残っているときだけ戻す
        if (document.body.contains(btn)) btn.disabled = false;
      });
  });

  document.addEventListener('keydown', function (evt) {
    var el = drawer();
    if (evt.key === 'Escape' && el && el.classList.contains('is-open')) close();
  });

  /*
    750px 以上では #PageContainer に transform があり、中の position: fixed が画面基準にならず
    ヘッダーの下にも隠れるため、カートのセクションを body の直下へ移す
  */
  function moveToBody() {
    var section = document.getElementById('shopify-section-' + SECTION_ID);
    if (section && section.parentNode !== document.body) document.body.appendChild(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveToBody);
  } else {
    moveToBody();
  }

  window.CartDrawer = { add: add, open: open, close: close };
})();
